import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../routes/user/user.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class RoleChecker implements CanActivate {

    constructor(
        private router: Router,
        private userService: UserService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return new Promise<boolean>(async (resolve, reject) => {
            while (route.firstChild) {
                route = route.firstChild;
            }
            // console.warn("ROUTE DATA"); console.warn(route.data);

            if (route.data && Array.isArray(route.data["roles"])) {
                // console.warn("ROUTE DATA ROLES"); console.warn(route.data["roles"]);
                const roles: any[] = route.data["roles"];
                const admin: boolean = await this.userService.isAdmin();
                // console.warn("INSUFFICIENT RIGHTS");
                if (roles.includes("ADMIN") && !admin) {
                    this.router.navigate(['/home']);
                    resolve(false);
                    return;
                }
            }

            resolve(true);
        });
    }
}